import { Box, BoxProps } from '@mui/material';
import ataNavLogo from '@/assets/logos/ata-nav.png';
import ataSquareLogo from '@/assets/logos/ata-square.png';
import ataIconLogo from '@/assets/logos/ata-icon.png';
import ataMediumLogo from '@/assets/logos/ata-medium.png';
import ataNavWhiteLogo from '@/assets/logos/ata-nav-white.png';
import ataLogoTransparent from '@/assets/logos/ata-logo-transparent.svg';

export interface AppLogoProps extends Omit<BoxProps, 'component'> {
  variant?: 'nav' | 'square' | 'icon' | 'medium' | 'nav-white' | 'header-white';
  height?: number | string;
  width?: number | string;
}

/**
 * ATA Digital Logo Component
 * Displays the ATA company logo in various sizes/formats
 *
 * @param variant - Logo variant: 'nav' (150x50), 'square' (100x100), 'icon' (64x64), 'medium' (200x67), 'nav-white' (white text on transparent)
 * @param height - Custom height override
 * @param width - Custom width override
 */
export function AppLogo({ variant = 'nav', height, width, sx, ...props }: AppLogoProps) {
  const logoMap = {
    nav: ataNavLogo,
    square: ataSquareLogo,
    icon: ataIconLogo,
    medium: ataMediumLogo,
    'nav-white': ataNavWhiteLogo,
    'header-white': ataLogoTransparent,
  };

  const defaultSizes = {
    nav: { width: 150, height: 50 },
    square: { width: 100, height: 100 },
    icon: { width: 64, height: 64 },
    medium: { width: 200, height: 67 },
    'nav-white': { width: 150, height: 50 },
    'header-white': { width: 120, height: 32 },
  };

  const size = defaultSizes[variant];

  return (
    <Box
      component="img"
      src={logoMap[variant]}
      alt="ATA Digital"
      sx={{
        width: width ?? size.width,
        height: height ?? size.height,
        objectFit: 'contain',
        ...sx,
      }}
      {...props}
    />
  );
}
